// material
import { styled, useTheme } from '@mui/material/styles';
import { Box, Divider, IconButton } from '@mui/material';
// hooks
import MuiDrawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// sidebar
import { CLOSED_SIDEBAR_WIDTH, NAVBAR_HEIGHT } from '../../theme/sizes';
import { useNavConfig, adminNav } from './NavConfig';
// components
import NavSection from './NavSection';
import Scrollbar from '../../components/Scrollbar';

// store
// import { usePermission } from '../../store/usePermission';

// import logoCleverCubo from '../../assets/logos-clever/logo-clever-cubo.svg';
import Logo from '../../components/Logo';

// ----------------------------------------------------------------------

const drawerWidth = 340;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  // width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: CLOSED_SIDEBAR_WIDTH(theme),
  },
});

const DrawerHeader = styled(Box)(({ theme, open }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  justifyContent: open ? 'flex-end' : 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  minHeight: `${NAVBAR_HEIGHT} !important`,
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

const ICONSIZE = 'medium';

// ----------------------------------------------------------------------

// export function reaload() {
//   window.location.reload(false);
// }

export default function DashboardSidebar({ open, setOpen }) {
  const theme = useTheme();
  const navBase = useNavConfig();
  const nav = navBase.concat(adminNav());

  const handleDrawerOpen = () => {
    setOpen((prevState) => !prevState);
  };

  const renderContent = (
    <Scrollbar
      sx={{
        overflowX: 'hidden',
        overflowY: 'auto',
        height: '100%',
        '& .simplebar-content': {
          minHeight: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
        },
      }}
    >
      {/* <GoBackButtonStyle
        sx={{
          opacity: !navigateBack && 0,
          pointerEvents: !navigateBack && 'none',
        }}
        onClick={() => navigate(navigateBack === true ? -1 : navigateBack)}
      >
        <Icon icon={GoBackIcon} fontSize={32} color={theme.palette.text.primary} />
      </GoBackButtonStyle> */}
      <NavSection navConfig={nav} isdraweropen={open} handledraweropen={handleDrawerOpen} />
    </Scrollbar>
  );

  return (
    <Box sx={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
      <Drawer variant="permanent" open={open}>
        <DrawerHeader open={open}>
          {open ? (
            <>
              <Box sx={{ width: 261, display: 'flex', justifyContent: 'center' }}>
                <Logo />
              </Box>
              <IconButton onClick={handleDrawerOpen} sx={{ color: 'inherit', justifySelf: 'flex-end' }}>
                {theme.direction === 'rtl' ? (
                  <ChevronRightIcon fontSize={ICONSIZE} />
                ) : (
                  <ChevronLeftIcon fontSize={ICONSIZE} />
                )}
              </IconButton>
            </>
          ) : (
            <IconButton
              size="small"
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
                marginLeft: 0,
              }}
            >
              <MenuIcon fontSize={ICONSIZE} />
            </IconButton>
          )}
        </DrawerHeader>
        <Divider />
        {renderContent}
      </Drawer>
    </Box>
  );
}
